// extracted by mini-css-extract-plugin
module.exports = {"share":"share_share__2_AHc","facebook":"share_facebook__37Ws7","twitter":"share_twitter__15sZ5","line":"share_line__3bhIS"};